import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { doFieldSettingUnload } from 'store/actions';
import { selectOrganisationFieldSettingsIsLoaded } from 'store/remote/selectors';
import { FieldSettingsSectionsScreen } from './FieldSettingsSectionsScreen';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.SETTINGS],
  Screens.SETTINGS_FIELDS
>;

export const FieldSettingsScreen: React.FC<Props> = ({ navigation, route }) => {
  const dispatch = useDispatch();

  const organisationFieldSettingsIsLoaded = useSelector(
    selectOrganisationFieldSettingsIsLoaded,
  );

  React.useEffect(() => {
    return () => {
      dispatch(doFieldSettingUnload());
    };
  }, [dispatch]);

  if (!organisationFieldSettingsIsLoaded) {
    return null;
  }

  return <FieldSettingsSectionsScreen navigation={navigation} route={route} />;
};
